var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPercent(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M11.857 15.058c2.398 0 3.234-1.606 3.234-3.586 0-2.002-.836-3.586-3.234-3.586-2.376 0-3.212 1.584-3.212 3.586 0 1.98.836 3.586 3.212 3.586zm.484 8.118c.198 0 .396-.11.484-.286l7.172-14.102a.65.65 0 00.044-.22.545.545 0 00-.55-.55.55.55 0 00-.484.286l-7.172 14.102c-.044.088-.044.154-.044.22 0 .308.242.55.55.55zm-.484-9.13c-1.672 0-2.112-1.188-2.112-2.574 0-1.408.44-2.574 2.112-2.574 1.694 0 2.134 1.166 2.134 2.574 0 1.386-.44 2.574-2.134 2.574zm8.14 9.24c2.398 0 3.234-1.606 3.234-3.586 0-2.002-.836-3.586-3.234-3.586-2.376 0-3.212 1.584-3.212 3.586 0 1.98.836 3.586 3.212 3.586zm0-1.012c-1.672 0-2.112-1.188-2.112-2.574 0-1.408.44-2.574 2.112-2.574 1.694 0 2.134 1.166 2.134 2.574 0 1.386-.44 2.574-2.134 2.574z"
  }));
}

export default SvgPercent;